export default AccessRuleService;

AccessRuleService.$inject = ['$window', 'Api', 'Identity'];
function AccessRuleService($window, Api, Identity) {
	const accountId = Identity.currentAccountId();

	const accessRulesManagementPageUrl = `${$window.BASE_URL}/core/accounts/${accountId}/access-rules`;

	return {
		accessRulesManagementPageUrl,

		fetchAccessRules,
		fetchHubRules,
		fetchRuleById,
	};

	async function fetchAccessRules() {
		// the backend extracts the user and the hub from the JWT
		return Api.get(`/v4/accounts/${accountId}/access-rules`).then(
			response => response.payload,
			() => []
		);
	}

	async function fetchRuleById(id) {
		if (id) {
			let response = await Api.get(`/v4/accounts/${accountId}/access-rules/${id}?expand=actions,groups,roles`);
			let rule = response.payload;

			return rule;
		} else {
			return null;
		}
	}

	async function fetchHubRules({ accountId, hubId }) {
		const { success, payload, errors } = await Api.get(`/v4/accounts/${accountId}/hubs/${hubId}/access-rules`);

		if (success) {
			return payload;
		} else {
			const error = new Error('Failed to Fetch Hub Access Rules');
			error.errors = errors;

			throw error;
		}
	}
}
